import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUp";
import OrdersPage from "./pages/OrdersPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import CounterPage from "./pages/CounterPage";
import ConsumerPage from "./pages/ConsumerPage";
import EmployeePage from "./pages/EmployeePage";
import AdminPage from "./pages/AdminPage";
import UserPage from "./pages/UserPage";
import NotFoundPage from "./pages/NotFoundPage";
import "react-toastify/dist/ReactToastify.css";
import UserDashboard from "./pages/UserDashboard";
import ConsumerMenu from './pages/ConsumerMenu'
import { AuthProvider } from "./state/AuthContext";
import ProtectedRoute from "./utils/ProtectedRoute";
import Admin from "./pages/AdminPage";
import HomePage from "./pages/HomePage";
import OnboardingForm from "./pages/OnboardingForm"
import BlogList from "./pages/BlogList";
import BlogPage from "./pages/BlogPage";
import Terms from "./pages/ZaffloTerms";
import MenuEditor from "./pages/MenuEditor"
import QrMenuForRestaurants from "./pages/QrMenuForRestaurants"
import HotelInRoomDiningSystem from "./pages/HotelInRoomDiningSystem"
import DigitalMenuIndia from "./pages/DigitalMenuIndia"
import MarketingTemplates from "./pages/ZaffloEnterpriseTemplates"
import ZaffloPodcast from "./pages/ZaffloPodcast";
import TaxReport from "./pages/GSTReports";
import usePageTracking from "./hooks/usePageTracking";
import QRMenuGeneratorPage from "./tools/QRMenuGeneratorPage";
import { HelmetProvider } from "react-helmet-async";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
function App() {
  
  
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </HelmetProvider>
   
  );
}

function AppRoutes() {
  usePageTracking(); // ✅ ADD HERE

  return (
      <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user"
            element={
              <ProtectedRoute role="user">
                <UserDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute role="user">
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/counter"
            element={
              <ProtectedRoute role="user">
                <CounterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute role="user">
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/employee"
            element={
              <ProtectedRoute role="employee">
                <EmployeePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/menueditor"
            element={
              <ProtectedRoute role="user">
                <MenuEditor />
              </ProtectedRoute>
            }
          />

          <Route
            path="/templates"
            element={
              <ProtectedRoute role="user">
                <MarketingTemplates />
              </ProtectedRoute>
            }
          />

          <Route
            path="/taxreport"
            element={
              <ProtectedRoute role="user">
                <TaxReport />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<ConsumerPage />} />
          <Route path="/home" element={<HomePage />} />
          {/*<Route path="/:id" element={<ConsumerPage />} />*/}
          <Route path="/Onboarding" element={<OnboardingForm />} />
          <Route path="/menu/:businessId" element={<ConsumerMenu />} />
          <Route path="/blogs" element={<BlogList />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blogs/:slug" element={<BlogPage />} />
          <Route path="/qr-menu-for-restaurants" element={<QrMenuForRestaurants />} />
          <Route path="/hotel-in-room-dining-system" element={<HotelInRoomDiningSystem />} />
          <Route path="/digital-menu-india" element={<DigitalMenuIndia />} />
          <Route path="/zafflo-podcast" element={<ZaffloPodcast />} />
          <Route path="/free-online-qr-menu-generator" element={<QRMenuGeneratorPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
  );
}

export default App;
